import { i18n } from "@src/app/i18n";

const order_place_dictionary: Record<string, string> = {
  store: i18n.global.t("Склад"),
  shopfloor: i18n.global.t("Зал"),
  fittingroom: i18n.global.t("Примерочные"),
  checkout: i18n.global.t("Кассы"),
};

export const getPlace = (place: string) => order_place_dictionary[place] ?? "";
